/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

import Button from '@material-ui/core/Button'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
/* eslint-disable react/prefer-stateless-function */
import cn from 'classnames'
import moment from 'moment'
import React from 'react'
import styled from 'styled-components'

import DatePicker from '../DatePicker/DatePicker'
import InputField from '../InputField'

const DropdownButtonWrapper = styled.div`
  &.stg-dropdown-button {
    height: 35px;
    position: relative;
    font-size: 14px;
    &:hover {
      cursor: pointer;
    }
    > .shape {
      display: flex;
      height: 100%;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #ccc;
      border-radius: 4px;

      > .value {
        padding: 0 0 0 7px;
        flex-grow: 1;
        white-space: nowrap;
        height: 100%;
        display: flex;
        align-items: center;
        color: #4a4a4a;
      }

      > .icon {
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    > .content {
      position: absolute;
      top: 37px;
      z-index: 1;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
      display: ${props => (props.showContent ? 'block' : 'none')};
    }
  }
`

const DatePickerWrapper = styled.div`
  background-color: #fff;
  max-width: 350px;

  &.date-picker-content {
    padding: 20px;
    border: 1px solid #d8d8d8;
    border-radius: 5px;
    > *:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  .handle-button-group {
    display: flex;
    justify-content: flex-end;

    > *:first-child {
      margin-right: 8px;
    }
  }
`

class DropdownButton extends React.Component {
  state = {
    showContent: false,
    from: '',
    to: '',
  }

  showDropdown = () => this.setState({ showContent: true })

  hideDropdown = () => this.setState({ showContent: false })

  toggleDropdown = () =>
    this.setState(prevState => ({
      ...prevState,
      showContent: !prevState.showContent,
    }))

  getValue = () => {
    const { from, to } = this.state
    const { format, defaultValue } = this.props

    if (from && to) {
      return `${moment(from).format(format)} - ${moment(to).format(format)}`
    }

    if (from) {
      return `After ${moment(from).format(format)}`
    }

    if (to) {
      return `Before ${moment(to).format(format)}`
    }

    return defaultValue
  }

  handleChangeStartDate = from => this.setState({ from })

  handleChangeEndDate = to => this.setState({ to })

  onApply = () => {
    const { from, to } = this.state
    this.setState({ showContent: false }, () => this.props.onApply({ from, to }))
  }

  onCancel = () => {
    const { from, to } = this.state
    this.setState(
      {
        showContent: false,
        from: this.props.from,
        to: this.props.to,
      },
      () => this.props.onCancel({ from, to })
    )
  }

  render() {
    const { className } = this.props
    const { from, to, showContent } = this.state
    return (
      <DropdownButtonWrapper showContent={showContent} className={cn(className, 'stg-dropdown-button')}>
        {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
        {/** biome-ignore lint/a11y/useAriaPropsSupportedByRole: TODO */}
        {/** biome-ignore lint/a11y/useKeyWithClickEvents: TODO */}
        <div className="shape" onClick={this.toggleDropdown} aria-label="Open Date Picker">
          <div className="value">{this.getValue() || 'All Time'}</div>
          <div className="icon">
            <ArrowDropDown />
          </div>
        </div>
        <DatePickerWrapper className="content date-picker-content">
          <InputField label="START DATE">
            <DatePicker selectedDate={from} allowEmpty onDateChange={this.handleChangeStartDate} />
          </InputField>
          <InputField label="END DATE">
            <DatePicker selectedDate={to} allowEmpty onDateChange={this.handleChangeEndDate} />
          </InputField>
          <div className="handle-button-group">
            <Button variant="contained" size="small" onClick={this.onCancel}>
              Cancel
            </Button>
            <Button color="primary" variant="contained" size="small" onClick={this.onApply}>
              Apply
            </Button>
          </div>
        </DatePickerWrapper>
      </DropdownButtonWrapper>
    )
  }
}

DropdownButton.defaultProps = {
  defaultValue: '',
  format: 'DD/MM/YYYY',
  onApply: f => f,
  onCancel: f => f,
}

export default DropdownButton
